export const dateFormat = (dateString: string) => {
  const [day, month, year] = dateString.split('-').map(Number);

  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
};
